angular.module('app.routes').constant('routeResolver', {
    emptyArray() {
        return [];
    },
    areasList(areasService) {
        return areasService.getAll();
    },
    areasListForUser(areasService, $sessionStorage) {
        return _.filter(areasService.getAll(), (area) => $sessionStorage.User.areas.includes(area.id));
    },
    filterAreasOptions($translate, areasService) {
        const areas = areasService.getAll();
        const options = [];

        options.push({
            value: 'from:0',
            label: $translate.instant('filter.area_from_any'),
        });
        angular.forEach(areas, (area) => {
            options.push({
                value: `from:${area.id}`,
                label: `${$translate.instant('filter.area_from_prefix') + area.symbol} ${area.name}`,
            });
        });
        options.push({
            value: 'to:0',
            label: $translate.instant('filter.area_to_any'),
        });
        angular.forEach(areas, (area) => {
            options.push({
                value: `to:${area.id}`,
                label: `${$translate.instant('filter.area_to_prefix') + area.symbol} ${area.name}`,
            });
        });

        return options;
    },
    areasOptions(areasService) {
        return areasService.selectize();
    },
    usersOptions(usersService) {
        return usersService.selectize();
    },
    allUserOptions(usersService) {
        const users = usersService.selectize({
            data: {
                all: true,
            },
        });

        return users.then((data) =>
            _.map(data, (user) => {
                user.areas_id = _.map(user.areas, (area) => area.id);

                return user;
            })
        );
    },
    permissionsList(permissionsService) {
        return permissionsService.getAll();
    },
    currencyOptions(dictionaryItemsService) {
        return dictionaryItemsService.selectize('currencies');
    },
    countryOptions(dictionaryItemsService) {
        return dictionaryItemsService.selectize('countries');
    },
    locationOptions(dictionaryItemsService) {
        return dictionaryItemsService.selectize('locations');
    },
    installationOptions(dictionaryItemsService) {
        return dictionaryItemsService.selectize('installation_type');
    },
    unitOptions(dictionaryItemsService) {
        return dictionaryItemsService.selectize('units');
    },
    woodworkOptions(dictionaryItemsService) {
        return dictionaryItemsService.selectize('woodwork');
    },
    taskStatusOptions(dictionaryItemsService) {
        return dictionaryItemsService.selectize('task_status');
    },
    projectStatusOptions(dictionaryItemsService) {
        return dictionaryItemsService.selectize('project_status');
    },
    phaseStatusOptions(dictionaryItemsService) {
        return dictionaryItemsService.selectize('phase_status');
    },
    interestStatusOptions(dictionaryItemsService) {
        return dictionaryItemsService.selectize('interest_phases');
    },
    userStatusOptions($translate) {
        return [
            { value: 'user_active', label: $translate.instant('user_active') },
            { value: 'user_inactive', label: $translate.instant('user_inactive') },
            { value: 'user_deleted', label: $translate.instant('user_deleted') },
            { value: 'user_suspended', label: $translate.instant('user_suspended') },
        ];
    },
    projectTypeOptions($translate) {
        return [
            { value: 'measurement', label: $translate.instant('projects.measurement') },
            { value: 'installation', label: $translate.instant('projects.installation') },
            { value: 'transport', label: $translate.instant('projects.transport') },
            { value: 'service', label: $translate.instant('projects.service') },
        ];
    },
    categoryOptions(dictionaryItemsService) {
        return dictionaryItemsService.selectize('task_types');
    },
    lossOptions(dictionaryItemsService) {
        return dictionaryItemsService.selectize('interest_loss');
    },
    serviceWorkOptions(dictionaryItemsService) {
        return dictionaryItemsService.selectize('service_work');
    },
    serviceTypeOptions(dictionaryItemsService) {
        return dictionaryItemsService.selectize('service_type');
    },
    transportTypeOptions(dictionaryItemsService) {
        return dictionaryItemsService.selectize('transport_type');
    },
    packagingMethodOptions(dictionaryItemsService) {
        return dictionaryItemsService.selectize('packaging_method');
    },
    usersList(usersService) {
        return usersService.getAll();
    },
    jobsOptions(dictionaryItemsService) {
        return dictionaryItemsService.selectize('jobs');
    },
    allGroupsOptions(groupsService) {
        return groupsService.selectize({
            data: {
                all: true,
            },
        });
    },
    groupsOptions(groupsService) {
        return groupsService.selectize();
    },
    clientOptionsForProjectsFilter(projectsListFilterFactory, clientsService) {
        const filterValues = projectsListFilterFactory.prefill().getValues();
        const clientId = parseInt(filterValues['client_id'].id || 0);

        return clientId ? clientsService.findForFilter(clientId) : [];
    },
    clientOptionsForPhasesFilter(phasesListFilterFactory, clientsService) {
        const filterValues = phasesListFilterFactory.prefill().getValues();
        const clientId = parseInt(filterValues['project.client_id'].id || 0);

        return clientId ? clientsService.findForFilter(clientId) : [];
    },
    clientOptionsForInterestFilter(interestsListFilterFactory, clientsService) {
        const filterValues = interestsListFilterFactory.prefill().getValues();
        const clientId = parseInt(filterValues['client_id'].id || 0);

        return clientId ? clientsService.findForFilter(clientId) : [];
    },

    clientsList(clientsService, clientsListFilterFactory) {
        const filterValues = clientsListFilterFactory.prefill().getValues();
        return clientsService.getFiltered(filterValues);
    },

    clientsListFilter($q, clientsListFilterFactory) {
        const deferred = $q.defer();

        clientsListFilterFactory.getProviders(deferred);

        return deferred.promise;
    },
    investmentOptionsForProjectsFilter($q, api) {
        const deferred = $q.defer();

        api('investments')
            .list()
            .then((response) => {
                deferred.resolve(
                    response.data.map((investment) => ({
                        value: investment.id,
                        label: investment.name,
                    }))
                );
            });

        return deferred.promise;
    },
    usersListFilter($q, usersListFilterFactory) {
        const deferred = $q.defer();

        usersListFilterFactory.getProviders(deferred);

        return deferred.promise;
    },

    interestsList(interestsService, interestsListFilterFactory) {
        const filterValues = interestsListFilterFactory.prefill().getValues();
        return interestsService.getFiltered(filterValues);
    },

    interestsListFilter($q, interestsListFilterFactory) {
        const deferred = $q.defer();

        interestsListFilterFactory.getProviders(deferred);

        return deferred.promise;
    },

    phasesList(phasesService, phasesListFilterFactory) {
        const filterValues = phasesListFilterFactory.prefill().getValues();
        return phasesService.getFiltered(filterValues);
    },

    phasesListFilter($q, phasesListFilterFactory) {
        const deferred = $q.defer();

        phasesListFilterFactory.getProviders(deferred);

        return deferred.promise;
    },

    projectsList(projectsService, projectsListFilterFactory) {
        const filterValues = projectsListFilterFactory.prefill().getValues();
        return projectsService.getFiltered(filterValues);
    },

    projectsListFilter($q, projectsListFilterFactory) {
        const deferred = $q.defer();

        projectsListFilterFactory.getProviders(deferred);

        return deferred.promise;
    },

    tasksList(tasksService, tasksListFilterFactory) {
        const filterValues = tasksListFilterFactory.prefill().getValues();
        return tasksService.getFiltered(filterValues);
    },

    tasksListFilter($q, tasksListFilterFactory) {
        const deferred = $q.defer();

        tasksListFilterFactory.getProviders(deferred);

        return deferred.promise;
    },

    userData($stateParams, usersService) {
        if ($stateParams.id) {
            return usersService.find($stateParams.id);
        } else {
            return {
                id: 0,
            };
        }
    },
});
